'use client';

import { useStores } from '@/models';
import React, { useEffect, useMemo } from 'react';
import { ECouponState, ECouponType, ELayoutType, ICouponInfo } from '../type';
import './couponList.scss';

import CountdownBar from './countDownBar';
import CouponContent from './couponContent';
import Watermark from './watermark';

import { observer } from 'mobx-react';

interface CouponListProps {
  countdownEnable: boolean;
  layoutType: ELayoutType;
  currentMills: number;
  initialCouponInfos: ICouponInfo[];
  localInfo: any;
}

const CouponList: React.FC<CouponListProps> = observer(
  ({ countdownEnable, layoutType, currentMills, initialCouponInfos, localInfo }) => {
    const { cmsUkCouponStore } = useStores();
    const couponListId = (() => {
      return initialCouponInfos.map(({ batchId }) => batchId).join('-');
    })();

    useEffect(() => {
      if (!cmsUkCouponStore.couponListMap.get(couponListId)?.length) {
        cmsUkCouponStore.setCouponInfos(couponListId, initialCouponInfos);
      }
    }, []);

    const setCouponInfo = (updatedCoupon: ICouponInfo) => {
      cmsUkCouponStore.setCouponInfo(couponListId, updatedCoupon);
    };

    const layoutClassName = useMemo(() => {
      return (
        {
          [ELayoutType.OnePerRow]: 'OnePerRow',
          [ELayoutType.TwoPerRow]: 'TwoPerRow',
          [ELayoutType.MultiplePerRow]: 'MultiplePerRow',
        }[layoutType] || ''
        // }[ELayoutType.OnePerRow] || "" // mock
      );
    }, [layoutType]);

    const getCouponTypeClassName = useMemo(() => {
      return ({ couponType, couponState }: ICouponInfo) => {
        if ([ECouponState.AllClaimed, ECouponState.Expired].includes(couponState)) {
          return 'Disabled';
        }
        if (ECouponType.Off === couponType) {
          return 'Off';
        }
        if (ECouponType.ShippingOff === couponType) {
          return 'ShippingOff';
        }
        return '';
      };
    }, []);

    return (
      <div className={'Wrapper'}>
        <div className={`CouponList ${layoutClassName}`}>
          {cmsUkCouponStore.couponListMap?.get(couponListId)?.map((couponInfo) => (
            <li
              className={`CouponItem ${layoutClassName}  ${getCouponTypeClassName(couponInfo)}`}
              key={couponInfo.batchId}
            >
              <CouponContent
                couponInfo={couponInfo}
                setCouponInfo={setCouponInfo}
                localInfo={localInfo}
              />
              {countdownEnable && (
                <CountdownBar
                  currentMills={currentMills}
                  couponInfo={couponInfo}
                  setCouponInfo={setCouponInfo}
                />
              )}
              <Watermark
                couponState={couponInfo.couponState}
                couponGetState={couponInfo.couponGetState}
              />
              <div className='LeftPrefix' />
            </li>
          ))}
        </div>
      </div>
    );
  },
);

export default CouponList;
